module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay",
    attrs: {
      "id": "impressum"
    }
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('h2', [_vm._v("Impressum")]), _vm._v(" "), _c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Herausgeber")]), _vm._v(" "), _c('p', [_vm._v("Joachim Herz Stiftung"), _c('br'), _vm._v("\n        Langenhorner Chaussee 384"), _c('br'), _vm._v("\n        22419 Hamburg"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.joachim-herz-stiftung.de",
      "target": "blank"
    }
  }, [_vm._v("www.joachim-herz-stiftung.de")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n        © Joachim Herz Stiftung, 2017"), _c('br'), _vm._v("\n        Alle Rechte vorbehalten."), _c('br')]), _c('h3', [_vm._v("Produktion")]), _vm._v("\n        C.C. Buchner Verlag"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Programmierung und Design")]), _vm._v("\n        dpa-infografik"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Zahlenmaterial")]), _vm._v("\n        Eurostat, Institut der deutschen Wirtschaft Köln\n        "), _c('p')]), _vm._v(" "), _c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6141a605","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/overlays/Overlays.vue
// module id = 568
// module chunks = 0